import { FactoryContext } from '@sqior/react/factory';
import { UserPages } from '@sqior/viewmodels/user';
import RoleSelectionPage from './role-selection-page/role-selection-page';
import PairedDevicePage from './paired-device-page/paired-device-page';

export function UIUserPlugin(context: FactoryContext) {
  context.factory.add(UserPages.PageRoleSelection, RoleSelectionPage);
  context.factory.add(UserPages.PagePairedDevices, PairedDevicePage);
}
